import type { BoardroomDeliverable } from '../../../types';
import { madeBy } from './provenance';

/** The coloured "Built in / You / Chat / Noticed" tag in a card's corner. */
export default function MadeByTag({
  deliverable: d,
  title,
  testId,
}: {
  deliverable: Pick<BoardroomDeliverable, 'kind' | 'subject' | 'created_by'>;
  /** Hover text - the card's full origin line. */
  title?: string;
  testId?: string;
}) {
  const made = madeBy(d);
  if (!made) return null;
  return (
    <span className={`shrink-0 rounded px-1.5 text-[11px] ${made.className}`} title={title} data-testid={testId}>
      {made.label}
    </span>
  );
}
